import { DatePicker, type DatePickerProps } from "antd"
import React, { useState } from "react"

import "./styles.css"

export function CustomDatePicker(props: DatePickerProps) {
  const [open, setOpen] = useState(false)

  return (
    <DatePicker
      open={open}
      onOpenChange={setOpen}
      onKeyDown={(e) => {
        if (open && e.key === "Enter") {
          e.preventDefault()
          e.stopPropagation()
        }
      }}
      // cellRender={(current) => {
      //   if (!current) return null
      //
      //   const date = (current as any).$d as Date
      //   const isToday = dayjs.tz(date).isSame(dayjs().tz(), "day")
      //
      //   return (
      //     <div className={`ant-picker-cell-inner ${isToday ? "is-today" : ""}`}>
      //       {dayjs.tz(date).date()}
      //     </div>
      //   )
      // }}
      {...props}
    />
  )
}
